APP_CONTAINER_VERSION = '12.30.61';
APP_CORE_VERSION = '12.33.23';
APP_CONTAINER_NAME = 'self-revolving-fe';
APP_CORE_NAME = 'self-digital-core-fe';
